import React, { Component } from "react";
import { Drawer } from "antd";
import ApdexHelp from "./ApdexHelp";
import "../../styles/components/help-center.scss";
import ContactCenter from "./ContactCenter";
import AlertDrawer from "./AlertDrawer";

class HelpCenter extends Component {
  switchComponents = name => {
    switch (name) {
      case "apdex":
        return ["What is APDEX?", <ApdexHelp />];
      case "contacts":
        return ["Contact us", <ContactCenter />];
      case "alerts":
        return ["Alert Center", <AlertDrawer />];
      default:
        return undefined;
    }
  };

  render() {
    const NAME = 0;
    const COMPONENT = 1;
    const route = this.switchComponents(this.props.name);
    return (
      <Drawer
        title={route[NAME]}
        width={this.props.width}
        placement={this.props.placement}
        closable={this.props.closable}
        onClose={this.props.onClose}
        visible={this.props.visible}
      >
        {route[COMPONENT]}
      </Drawer>
    );
  }
}

export default HelpCenter;
